/**
 * @typedef {Object} PersonalizationStore
 * @property {Record<string, any>} data - The data storage object
 * @property {function(): boolean} isInitialized - Check if the store is initialized
 * @property {function(string, any): void} set - Set a value by key
 * @property {function(string): any} get - Get a value by key
 * @property {function(): Record<string, any>} getAll - Get all data
 */

/** @type {PersonalizationStore} */
export const P11N_STORE = {
  data: {},
  isInitialized() {
    return Object.keys(this.data).length > 0;
  },
  set(key, value) {
    this.data[key] = value;
  },
  get(key) {
    return this.data[key];
  },
  getAll() {
    return this.data;
  },
};
